import { createApi } from "@reduxjs/toolkit/query/react";
import { ApiKey, ApiKeySummary } from "@shared/interfaces";
import Methods from "@shared/constants/methods";
import { showProgress } from "@shared/utils";
import { axiosBaseQuery } from "@shared/utils/request";

import config from "../../../config";

export interface SaveApiKeysPayload {
  account_id: number;
  upsert: ApiKey[];
  delete: number[];
}

export const apiKeysApi = createApi({
  reducerPath: "apiKeysApi",
  baseQuery: axiosBaseQuery({
    baseUrl: `${config.baseApiUrl}api-keys`,
  }),
  tagTypes: ["ApiKeys", "ApiKeysSummary"],
  endpoints: (build) => ({
    getApiKeysSummary: build.query<ApiKeySummary, number>({
      providesTags: ["ApiKeysSummary"],
      query: (account_id) => ({
        url: "/summary",
        params: { account_id },
      }),
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        showProgress(dispatch, queryFulfilled);
      },
    }),
    getApiKeysList: build.query<ApiKey[], number>({
      providesTags: ["ApiKeys"],
      query: (account_id) => ({
        url: "",
        params: { account_id },
      }),
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        showProgress(dispatch, queryFulfilled);
      },
    }),
    saveApiKeys: build.mutation<ApiKey[], SaveApiKeysPayload>({
      query: (data: SaveApiKeysPayload) => ({
        url: "",
        method: Methods.PUT,
        body: data,
      }),
      invalidatesTags: ["ApiKeysSummary"],
      onQueryStarted: (arg, { dispatch, queryFulfilled }) => {
        showProgress(dispatch, queryFulfilled);
        queryFulfilled.then((result) => {
          dispatch(apiKeysApi.util.updateQueryData("getApiKeysList", arg.account_id, () => result.data));
        });
      },
    }),
  }),
});

export const { useSaveApiKeysMutation, useGetApiKeysListQuery, useGetApiKeysSummaryQuery } = apiKeysApi;
